import { createRoutine } from 'redux-saga-routines';

export const validateIntegration = createRoutine('VALIDATE_INTEGRATION');

export const disconnectIntegration = createRoutine(
  'DISCONNECT_ZENDESK_INTEGRATION'
);

export const zedeskAuthentication = createRoutine('ZENDESK_AUTHENTICATION');

export const zendeskEntityMapping = createRoutine('ZENDESK_ENTITY_MAPPING');

export const goToMappingStep = createRoutine('GO_TO_MAPPING_STEP');

export const fetchZendeskEntityMapping = createRoutine(
  'FETCH_ZENDESK_ENTITY_MAPPING'
);

export const changeMappingSavedStatus = createRoutine(
  'CHANGE_MAPPING_SAVED_STATUS'
);

export const fetchZendeskProperties = createRoutine('FETCH_ZENDESK_PROPERTIES');
